import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { isEntryOnlyLanguage } from '@/Config/app/entryLocale';
import { LanguageSwitcher } from '@/Domain/components/App/LanguageSwitch/LanguageSwitch';

export const EntryLanguageControl = () => {
  const { t, i18n } = useTranslation('entry_language');
  const language = i18n.resolvedLanguage ?? 'en';

  useEffect(() => {
    const { lang, dir } = document.documentElement;
    document.documentElement.lang = language;
    document.documentElement.dir = i18n.dir(language);
    return () => {
      document.documentElement.lang = lang;
      document.documentElement.dir = dir;
    };
  }, [i18n, language]);

  return (
    <div className="flex flex-col items-center gap-2" data-testid="entry-language-control">
      <div className="max-w-full">
        <LanguageSwitcher entry />
      </div>
      {isEntryOnlyLanguage(language) && (
        <p
          className="text-xs text-muted-foreground text-center max-w-sm"
          data-testid="entry-language-notice"
        >
          {t('partial_notice')}
        </p>
      )}
    </div>
  );
};
